import API from "./API"

const fetchJohnDeereUrls = (org_id) => {
  if(org_id !== undefined) {
    return API.get(`jdurl/?orgid=${org_id}`)
  }
  return API.get("jdurl")
}

const fetchJohnDeereConnectionErrors = () => API.get("/jdauth/unread_errors/")

const fetchJohnDeereStage = () => API.get("jd-stage")

const fetchJohnDeereOrgs = () => API.get("/jd-org")

const refreshJohnDeereOrgs = () => API.get("/jd-org/refresh/")

const fetchJohnDeereSynclog = (synclog_id) => API.get(`/jd-org-synclogs/${synclog_id}/`)

const importJohnDeereData = (data_type, payload) =>
  API.post(`/jd-org/import_data/?data_type=${data_type}`, payload)

const configureJohnDeereOrg = payload => API.post(`/jd-org/set_org/`, payload)

const updateJohnDeereClients = (pk, payload) => API.post(`/jd-org/${pk}/set_clients/`, payload)

export default {
  fetchJohnDeereUrls, fetchJohnDeereStage, fetchJohnDeereOrgs, refreshJohnDeereOrgs,
  fetchJohnDeereSynclog, importJohnDeereData, configureJohnDeereOrg, updateJohnDeereClients,
  fetchJohnDeereConnectionErrors,
}
